<div class="row">
  <div class="col-12">
    <div class="card p-3 mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="page-title">Spot Booking</h4>
        <button
          class="btn btn-primary ml-3"
          routerLink="/user/spot-booking/create"
        >
          + Create Booking
        </button>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Spot Image</th>
              <th scope="col">Spot Name</th>
              <th scope="col">Asset Type</th>
              <th scope="col">Start Date</th>
              <th scope="col">End Date</th>
              <th scope="col">Check-in Time</th>
              <th scope="col">Check-out Time</th>
              <th scope="col">Spot Description</th>
              <th scope="col">Slot Duration</th>
              <th scope="col">Slot Category</th>
              <th scope="col">Create Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let booking of beachBookings">
              <td>
                <img
                  src="{{ booking.beachImage }}"
                  alt="Spot Image"
                  width="100"
                  class="img-thumbnail"
                />
              </td>
              <td>{{ booking.title }}</td>
              <td>{{ booking.assetType }}</td>
              <td>{{ booking.startDate }}</td>
              <td>{{ booking.endDate }}</td>
              <td>{{ booking.checkInTime }}</td>
              <td>{{ booking.checkOutTime }}</td>
              <td>{{ booking.description }}</td>
              <td>{{ booking.timing }}</td>
              <td>
                {{ booking.categoryId?.name ? booking.categoryId.name : "-" }}
              </td>
              <td>{{ booking.created_at | date : "short" }}</td>
              <td>
                <a
                  href="javascript:void(0);"
                  class="link mr-2"
                  ngbTooltip="Edit"
                  (click)="editBooking(booking._id)"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a
                  href="javascript:void(0);"
                  class="link mr-2 text-danger"
                  ngbTooltip="Delete"
                  (click)="deleteBooking(booking._id)"
                >
                  <i class="fa fa-trash"></i>
                </a>
                <a
                  href="javascript:void(0);"
                  class="link mr-2 text-info"
                  ngbTooltip="View"
                  (click)="viewBookingDetails(booking._id)"
                >
                  <i class="fa fa-eye"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="beachBookings.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalcount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #deleteBeachModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Remove Spot</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this beach ?</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="removeBeach(deleteModalId)"
    >
      Remove Zone
    </button>
  </div>
</ng-template>
